import type { Order } from '@src/orders/domain/Order';
import type { PermitApplication } from '@src/orders/domain/PermitApplication';
import { BilingualField } from '@src/permitField/AccountFields';
import {
  InsuranceAddressNumberField,
  InsuranceAgentField,
  InsuranceCompanyField,
  InsuranceCoverageAmountField,
  InsuranceEffectiveDateField,
  InsuranceExperienceDateField,
  InsuranceIsOnFileWithStateField,
  InsurancePhoneNumberField,
  InsurancePolicyNumberField,
} from '@src/permitField/InsuranceInformationFields';
import {
  abMVIDNumberField,
  bcCustomerNumber,
  bcFINNumber,
  federalIdNumber,
  kentuckyNumber,
  laNumber,
  montanaNumber,
  nlMasterNumber,
  onCVORNumber,
  onPRIOAccountNumber,
  oregonNumber,
  qcNEQNumber,
  qcNIRNumber,
  tennesseeNumber,
  texasNumber,
  usDotNumber,
  usICC,
  usIFTA,
  usIRP,
} from '@src/permitField/JurisdictionIdNumberFields';
import { CategorySection } from '@src/permits/CategorySection';
import { useTranslation } from 'react-i18next';

export const AccountsAndInsuranceCategory = ({
  permitApplication,
  order,
}: {
  permitApplication: PermitApplication;
  order: Order;
}) => {
  const { t } = useTranslation();
  const fields = permitApplication.getFieldsBySection('accountsAndInsurances');
  if (fields.size === 0) return null;

  return (
    <CategorySection
      title={t('orderSections.accountsAndInsurances')}
      requiredFields={Array.from(fields.values()).flat()}
      permitApplication={permitApplication}
      order={order}
      subsections={[
        { label: t('account'), fields: [BilingualField.fieldName] },
        {
          label: t('insuranceInformation'),
          fields: [
            InsuranceCompanyField.fieldName,
            InsuranceAddressNumberField.fieldName,
            InsuranceEffectiveDateField.fieldName,
            InsuranceExperienceDateField.fieldName,
            InsurancePolicyNumberField.fieldName,
            InsuranceCoverageAmountField.fieldName,
            InsuranceAgentField.fieldName,
            InsurancePhoneNumberField.fieldName,
            InsuranceIsOnFileWithStateField.fieldName,
          ],
        },
        {
          label: t('juridictionIds'),
          fields: [
            abMVIDNumberField.fieldName,
            bcCustomerNumber.fieldName,
            bcFINNumber.fieldName,
            qcNEQNumber.fieldName,
            qcNIRNumber.fieldName,
            onCVORNumber.fieldName,
            onPRIOAccountNumber.fieldName,
            nlMasterNumber.fieldName,
            usICC.fieldName,
            usIFTA.fieldName,
            usIRP.fieldName,
            usDotNumber.fieldName,
            federalIdNumber.fieldName,
            kentuckyNumber.fieldName,
            laNumber.fieldName,
            montanaNumber.fieldName,
            oregonNumber.fieldName,
            tennesseeNumber.fieldName,
            texasNumber.fieldName,
          ],
        },
      ]}
    />
  );
};
